/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count down to New Year, a birthday or a product launch.`)
};

const es_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta atrás hasta Año Nuevo, un cumpleaños o el lanzamiento de un producto.`)
};

const de_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähle bis Neujahr, einem Geburtstag oder einem Produktlaunch herunter.`)
};

const nl_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel af naar Oud en Nieuw, een verjaardag of een productlancering.`)
};

const fr_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez à rebours vers le Nouvel An, un anniversaire ou le lancement d'un produit.`)
};

const it_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai il conto alla rovescia per Capodanno, un compleanno o il lancio di un prodotto.`)
};

const pt_br2_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça a contagem regressiva para o Ano Novo, um aniversário ou o lançamento de um produto.`)
};

const pt_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça a contagem decrescente até à Passagem de Ano, um aniversário ou o lançamento de um produto.`)
};

const ja_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新年、誕生日、製品発売までカウントダウンできます。`)
};

const zh_cd_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时到新年、生日或产品发布日。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_ex1", locale)
	if (locale === "en") return en_cd_ex1(inputs)
	if (locale === "es") return es_cd_ex1(inputs)
	if (locale === "de") return de_cd_ex1(inputs)
	if (locale === "nl") return nl_cd_ex1(inputs)
	if (locale === "fr") return fr_cd_ex1(inputs)
	if (locale === "it") return it_cd_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_cd_ex1(inputs)
	if (locale === "pt") return pt_cd_ex1(inputs)
	if (locale === "ja") return ja_cd_ex1(inputs)
	return zh_cd_ex1(inputs)
};